module.exports = __webpack_public_path__ + "img/image (3).afb4366b.webp";